import { createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import { auth, firestore as db } from "../config/Config";


const  initialState={
    roomNames:[],
  roomModal:false,
  roomError:{}
}

export const createRooms = createAsyncThunk('createRoomList',
  async ({ clientId, roomData }, { rejectWithValue }) => {
    try {
      const response = await fetch(`https://us-central1-fabdiz-quote.cloudfunctions.net/api/project-rooms/${clientId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(roomData),
      });

      if (!response.ok) {
        throw new Error('Server Error');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
const addRoomReducer = createSlice({
    name:'createRoom',
    initialState: {
    rooms: [],
    loading: false,
    error: null,
  },
    reducers:{},
    extraReducers: (builder) => {
      builder
        .addCase(createRooms.pending, (state) => {
          state.loading = true;
        })
        .addCase(createRooms.fulfilled, (state, action) => {
          // state.rooms.push(action.payload);
          state.loading = false;
        })
        .addCase(createRooms.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        });
    },
});

export default addRoomReducer.reducer